import apiConfig from "../config/api";
import { get, post, put, requestDelete } from "../helpers/request";

const achsOffice = `${apiConfig.apiUri}api/sel/achsoffice`;

const openingUrl = `${apiConfig.apiUri}api/sel/opening`;

const quota = `${apiConfig.apiUri}api/sel/quotas/`;

export const GetOfficeAchs = () => get(`${achsOffice}/all`);
export const GetCenterConfiguration = (centroId) => get(`${achsOffice}/${centroId}`);
export const GetAllOpeningsMonth = (centro, start, end) =>
  get(`${openingUrl}/all`, {
    params: {
      centerId: centro,
      start,
      end,
    },
  });

export const getAllOpeningsWeek = (centerId, start, end) =>
  get(`${openingUrl}/modules`, {
    params: { centerId, start, end },
  });
export const createdOpening = (opening) => post(
  `${openingUrl}`,
  {
    body: JSON.stringify(opening),
  }
);
export const updateOpening = (opening) => put(
  `${openingUrl}`,
  {
    body: JSON.stringify(opening),
  }
);
export const getAllQuotes = () => get(`${quota}/all`);

export const deleteOpeningById = (id) => requestDelete(`${openingUrl}/${id}`);

export const getAllConfigurationList = (IdCentro) => get(`${openingUrl}/configurations/all?centerId=${IdCentro}`);
export const getConfigurationById = (id) => get(`${openingUrl}/configurations?configurationId=${id}`);
